// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import "firebase/storage";
import { getStorage } from "firebase/storage";

//PROD
const firebaseConfig = {
  apiKey: "AIzaSyCXZNPbGtOQqDg4lDKP5HcGpuvfcj0laVw",
  authDomain: "comitty-79c84.firebaseapp.com",
  firebaseApiUrl: "https://europe-west1-comitty-79c84.cloudfunctions.net",
  projectId: "comitty-79c84",
  storageBucket: "comitty-79c84.appspot.com",
  messagingSenderId: "693965467441",
  appId: "1:693965467441:web:5eee79b98993aa5e4aca10",
  measurementId: "G-BRHCG56K2K",
};

//DEV
// const firebaseConfig = {
//   apiKey: "AIzaSyDD16SpjPFAVOHcaCHh5ImqyWR8Wu6LvdU",
//   authDomain: "yummi-events.firebaseapp.com",
//   projectId: "yummi-events",
//   storageBucket: "yummi-events.appspot.com",
//   messagingSenderId: "682329574488",
//   appId: "1:682329574488:web:b6f7ca996088e796a30e2d",
//   measurementId: "G-7RDSZ4EPZQ",
//   firebaseApiUrl: "https://europe-west1-yummi-events.cloudfunctions.net"
// };

export const app = initializeApp(firebaseConfig);
// Export firestore database
// It will be imported into your react app whenever it is needed
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
